import { Component, OnInit, EventEmitter, Input, Output } from "@angular/core";
import { LoginService } from "../login.service";
@Component({
    selector: "app-searchbox",
    templateUrl: "./searchbox.component.html",
    styleUrls: ["./searchbox.component.scss"],
    standalone: false
})
export class SearchboxComponent implements OnInit {
  @Output() closed = new EventEmitter<any[]>();
  @Output() closeReports = new EventEmitter<any[]>();
  @Input("startdate") startdate: Date;
  @Input("enddate") enddate: Date;
  @Input("exams") exams;
  @Input("examtype") etype = "All";
  @Input("reportstype") reportstype: "AllReports" | "HMO" | "Refferelnum" = "AllReports";
  @Input("hmostype") hmostype: "Macabi" | "Leumit" | "Meuhedet" | "Clalit" | "Private" | "IDF" | "null" =
    "Macabi";

  @Input("isGastro") isGastro;
  @Input("isReports") isReports;
  searchmin = null;
  searchmax = null;

  cansearch = true;

  constructor(public loginService: LoginService) {}

  ngOnInit() {
    if (this.isReports) {
      this.searchmax = new Date(new Date().setDate(new Date().getDate() - 1));
      this.enddate = this.searchmax;

      this.searchmin = new Date(new Date().setDate(new Date().getDate() - 1));
      this.startdate = this.searchmin;
    }
  }

  search() {
    let vals = [this.startdate, this.enddate, this.exams, this.etype];
    if (this.isReports)
      vals = [
        this.startdate,
        this.enddate,
        [],
        this.reportstype,
        this.hmostype,
      ];

    this.closed.emit(vals);
  }

  setVals(mode: string) {
    switch (mode) {
      case "All":
        for (let e in this.exams) {
          this.exams[e] = true;
        }
        break;
      case "Refferelnum":
      case "HMO":
      case "Clalit":
      case "AllReports":
        this.cansearch = true;
        break;
    }
    this.cansearch = this.hasExam();
  }

  setE(event, exam: string) {
    if (event.srcElement.type != "checkbox") {
      return;
    }
    this.exams[exam] = !this.exams[exam];
    this.cansearch = this.hasExam();
  }

  hasExam(): boolean {
    if (!this.exams) {
      return false;
    }
    for (let e in this.exams) {
      if (this.exams[e]) {
        return true;
      }
    }
    //if nothing
    return false;
  }
}
